import { render } from "./CustomerNoteTile.vue?vue&type=template&id=6e638bb6&scoped=true"
import script from "./CustomerNoteTile.vue?vue&type=script&lang=ts"
export * from "./CustomerNoteTile.vue?vue&type=script&lang=ts"

import "./CustomerNoteTile.vue?vue&type=style&index=0&id=6e638bb6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6e638bb6"

export default script